/**
 * @desc 分页查询tob税务报表
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<
  defs.tms.IPage<defs.tms.CustomsClearanceDetailReportExcelResponseDto>
>;
export function request(
  params: API.tms.customsClearance.getCustomsClearanceDetailPageList.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/customsClearance/getCustomsClearanceDetailPageList`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
